import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { DuplicateMenuRequestSchema } from '~/services/api/generated'

const schema = DuplicateMenuRequestSchema.strict()

export const MenuDuplicate = (_context: NoContext): z.ZodType<z.output<typeof schema>> => schema
